import { Flex, Heading } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { FormikSwitchInput } from "src/components/Inputs/FormikSwitchInput";
import { InputControlWithMaxLength } from "src/components/Inputs/InputControlWithMaxLength";
import { LexicalControlWithMaxLength } from "src/components/Inputs/LexicalControlWithMaxLength";
import { AdminCard } from "src/components/Layout/AdminCard";
import { FormikType, MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from "./Formik";

export const AdditionalContentCard = () => {
  const formik = useFormikContext<FormikType>();
  return (
    <AdminCard
      title={
        <Heading as="h3" variant="admin">
          Additional content
        </Heading>
      }
      description="An optional section to add additional information."
      actions={
        <FormikSwitchInput
          checked={["enabled", ""]}
          unchecked={["disabled", ""]}
          name="additionalContent.status"
        />
      }
    >
      {formik.values.additionalContent.status === "enabled" ? (
        <Flex direction="column" gap="4">
          <InputControlWithMaxLength
            label="Title"
            id="additionalContent.title"
            name="additionalContent.title"
            maxLength={MAX_TITLE_LENGTH}
          />
          {/* We don't support rich content for description yet, but I foresee that this request will come soon, so I'm preparing for it by using lexical with hidden toolbar for now. */}
          <LexicalControlWithMaxLength
            label="Description"
            name="additionalContent.description"
            maxLength={MAX_DESCRIPTION_LENGTH}
            plainFieldName="additionalContent.plainDescription"
            format="html"
            height="5rem"
            settings={{
              enableSmsStats: false,
              enableVariables: false,
              enableAutofocus: false,
              enableCode: false,
            }}
          />
        </Flex>
      ) : null}
    </AdminCard>
  );
};
